import styled from "styled-components";

interface MyraContainer {
  device: string;
}

export const RightPersuasionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  height: 34px;
  justify-content: center;
  line-height: 21px;
  padding: 5px 0 5px 6px;
  width: 150px;
`;

export const PersuasionText = styled.p`
  display: flex;
  max-height: 100%;
  overflow: hidden;
  color: #262626;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  height: 18px;
  line-height: 21px;
`;

export const PersuasionTextSpan = styled.span`
    line-height: 18px;
    color: #000000;
    font-weight: 600;
    font-size: 16px;
    cursor pointer;
`;

export const MyraContainer = styled.div<MyraContainer>`
  position: fixed;
  bottom: 40px;
  right: 200px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  cursor: pointer;
`;

export const MyraIconContainer = styled.div`
  border: 4px solid rgb(200, 109, 215);
  background-color: rgb(255, 255, 255);
  border-radius: 50px;
  width: 218px;
  overflow: hidden;
  align-items: center;
  display: flex;
  height: 68px;
`;

export const Icon = styled.div`
  padding-top: 5px;
  background-color: #f5f5f5;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;

export const MyraBorder = styled.div`
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
